import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';
import Popup from './Popup';
import { findTargetElementsParent } from './util';
import DropdownItem from './DropdownItem';
import DropdownDivider from './DropdownDivider';
import DropdownList from './DropdownList';

var Dropdown = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Dropdown, _React$PureComponent);

  var _super = _createSuper(Dropdown);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _super.apply(this, arguments);
    _this.rootDOM = null;
    _this.popupComp = null;
    _this.rendered = false;
    /**
     * 当下拉菜单与 target 元素有 margin 间距的时候 鼠标画过间隙容易触发 mouseLeave 从而误关闭菜单，
     * 这里涉及延时 200sm 关闭菜单，避免误操作
     */

    _this.hoverDelayClose = null;
    _this.state = {
      showPopup: false
    };

    _this.handleMouseEnter = function () {
      if (_this.hoverDelayClose) {
        window.clearTimeout(_this.hoverDelayClose);
      }

      _this.changeShowPopup(true);
    };

    _this.handleMouseLeave = function () {
      _this.hoverDelayClose = window.setTimeout(function () {
        _this.changeShowPopup(false);

        _this.hoverDelayClose = null;
      }, 200);
    };

    _this.handleClick = function () {
      _this.changeShowPopup(!_this.state.showPopup);
    };

    _this.handleSelect = function (_ref) {
      var label = _ref.label;
      if (_this.props.onSelect) _this.props.onSelect(label);
    };

    _this.handleOutsideClick = function (e) {
      if (!_this.state.showPopup || !e.target || !_this.popupComp || !_this.popupComp.rootDOM) {
        return;
      }

      if (e.target instanceof HTMLElement && !findTargetElementsParent(e.target, [_this.rootDOM, _this.popupComp.rootDOM])) {
        _this.changeShowPopup(false);
      }
    };

    _this.getPopupRef = function (ref) {
      if (!_this.popupComp && ref) {
        _this.popupComp = ref;
      }
    };

    _this.getRootDOM = function (ref) {
      if (_this.rendered) return;
      _this.rendered = true;
      _this.rootDOM = ref;
    };

    _this.renderContent = function () {
      return [_this.props.children, /*#__PURE__*/React.createElement(Popup, {
        width: _this.props.width,
        isShow: _this.state.showPopup,
        target: _this.rootDOM,
        className: classnames('roo-dropdown', 'roo-dropdown-menu', _this.props.popupClassName),
        placement: _this.props.placement,
        ref: _this.getPopupRef,
        updatePlacementOnScroll: false,
        key: "dropdown-popup"
      }, _this.props.menuComponent ? _this.props.menuComponent : _this.renderMenu(_this.props.menu))];
    };

    _this.changeShowPopup = function (val) {
      if (val === _this.state.showPopup) {
        return;
      }

      _this.setState({
        showPopup: val
      });

      if (val) {
        if (_this.props.onShow) _this.props.onShow();
      } else {
        if (_this.props.onHide) _this.props.onHide();
      }
    };

    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.trigger === 'click') {
        document.addEventListener('click', this.handleOutsideClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.trigger === 'click') {
        document.removeEventListener('click', this.handleOutsideClick);
      }
    }
  }, {
    key: "renderMenu",
    value: function renderMenu(menuData) {
      var _this2 = this;

      if (!menuData) {
        return null;
      }

      return /*#__PURE__*/React.createElement(DropdownList, null, menuData.map(function (item, index) {
        if (item === '') return /*#__PURE__*/React.createElement(Dropdown.Divider, {
          key: index
        });

        if (typeof item === 'string') {
          return /*#__PURE__*/React.createElement(DropdownItem, {
            label: item,
            key: item,
            onClick: _this2.handleSelect
          });
        }

        return /*#__PURE__*/React.createElement(DropdownItem, {
          label: item.label,
          link: item.link,
          key: item.label,
          onClick: _this2.handleSelect
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.trigger === 'hover' ? /*#__PURE__*/React.createElement("div", {
        ref: this.getRootDOM,
        className: classnames('Dropdown', this.props.className),
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, this.renderContent()) : /*#__PURE__*/React.createElement("button", {
        className: classnames('roo-btn', 'roo-button', 'roo-btn-default', this.props.className),
        onClick: this.handleClick,
        ref: this.getRootDOM,
        type: "button"
      }, this.renderContent(), /*#__PURE__*/React.createElement("i", {
        className: classnames('roo-icon', this.state.showPopup ? 'roo-icon-arrow-up' : 'roo-icon-arrow-down')
      }));
    }
  }]);

  return Dropdown;
}(React.PureComponent);

Dropdown.propTypes = {
  menu: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    label: PropTypes.string.isRequired,
    link: PropTypes.string
  }), PropTypes.string])),
  width: PropTypes.string,
  placement: PropTypes.oneOf(['bottomLeft', 'bottomRight', 'topLeft', 'topRight', 'bottom', 'top']),
  trigger: PropTypes.oneOf(['hover', 'click']),
  onSelect: PropTypes.func,
  onShow: PropTypes.func,
  onHide: PropTypes.func,
  className: PropTypes.string,
  popupClassName: PropTypes.string
};
Dropdown.defaultProps = {
  trigger: 'hover',
  placement: 'bottomLeft',
  width: 'auto',
  menu: null,
  className: null,
  popupClassName: null,
  onSelect: function onSelect() {},
  onShow: function onShow() {},
  onHide: function onHide() {}
};
Dropdown.Item = DropdownItem;
Dropdown.List = DropdownList;
Dropdown.Divider = DropdownDivider;
export default Dropdown;